module.exports = __webpack_public_path__ + "static/media/Hisco_logo.10da680d.png";